import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { WatchdogMaterialModule } from 'src/app/material-module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * Sign-in. There is no credential form here any more: authentication happens at Cognito's hosted
 * login, and this page only starts that redirect and handles the return.
 *
 * It also completes the authorization code exchange, because Cognito redirects back to the
 * application root after sign-in.
 */
@Component({
  selector: 'app-login',
  styleUrl: './login.component.css',
  templateUrl: './login.component.html',
  imports: [CommonModule, WatchdogMaterialModule, MatProgressSpinnerModule],
  standalone: true,
})
export class LoginComponent implements OnInit {

  private readonly oidc = inject(OidcSecurityService);
  private readonly router = inject(Router);

  checking = true;
  error: string | null = null;

  ngOnInit(): void {
    this.oidc.checkAuth().subscribe({
      next: ({ isAuthenticated }) => {
        this.checking = false;
        if (isAuthenticated) {
          this.router.navigate(['/admin/dashboard']);
        }
      },
      error: err => {
        this.checking = false;
        this.error = 'Could not complete sign-in: ' + (err?.message ?? err);
      },
    });
  }

  signIn(): void {
    this.oidc.authorize();
  }
}
